<template>
<div>
  <Tabs :animated="false"type="card">
    <TabPane label="解约信息" name="0">
      <termination-info @showimg="showImg" :infoData="infoData"></termination-info>
    </TabPane>
    <TabPane label="交割信息" name="1">
      <delivery @showimg = "showImg" :n="deliveryKey" :surrenderFid = "surrenderFid" :parentSurrenderFid="parentSurrenderFid" :contractFid="contractFid"></delivery>
    </TabPane>
    <TabPane label="结算信息" name="2">
      <balance-info :balanceInfo="balanceInfo"
                    :projectName="projectName"
                    :n="getEnterpriseBalanceKey"
                    :surrenderFid="surrenderFid"
                    :parentSurrenderFid="parentSurrenderFid"
                    :contractFid="contractFid"
                    v-if="surrenderFid"

      ></balance-info>
    </TabPane>
    <div slot="extra">
<!--      <a class="tab-right" target="_blank" v-if="infoData && infoData.protocolUrl" :href="infoData.protocolUrl">解约协议文本查看</a>-->
      <a href="javascript:void(0)"  @click.stop="getSignedText" style="margin-right: 15px">解约协议文本查看</a>

      <a href="javascript:void(0)" @click.stop="pN++" v-if="voucherListNum">查看凭证</a>


      <z-upload
        action="/file/uploadFile"
        @uploadSuccess="uploadSuccess"
        :format="['gif','jpg','jpeg','png','GIF','JPG','PNG']"
      >
        <a href="javascript:;"  class="tab-right">上传凭证</a>
      </z-upload>
    </div>
  </Tabs>
  <div class="audit-btn-wrap " v-if="isAudit">
    <Button type="primary" size="large" @click="pass">通过</Button>
    <Button type="primary" size="large" @click="dismissed">驳回 </Button>
  </div>
  <img-show :n="showImgKey" :src="imgSrc"></img-show>
    <dismissed-modal :n="dismissedKey" :surrenderFid="surrenderFid" @closeTag = "closeTag"></dismissed-modal>

  <protocol-list :n="pN" :fid="surrenderFid" ref="vlist" @num="setNum"></protocol-list>
</div>


</template>

<script type="text/ecmascript-6">
import {getBaseUrl} from "@/utils/public";
import { getSurrenderInfo,getEnterpriseBalance,confirmSurrAudit ,getSignedText} from 'api/termination'
import TerminationInfo from './components/TerminationInfo'
import Delivery from './../../components/CompanyDeliveryInfo'
import DismissedModal from './../components/DismissedModal'
import ImgShow from 'components/ImgShow/index'
import BalanceInfo from './components/BalanceInfo'

import ProtocolList from '../personalTerminationDetail/components/ProtocolList'
import ZUpload from '@/components/upload/index';
import {uploadVoucher} from "../../../../api/contractList";


export default {
  name:'companyterminationdetail1',
  created(){
    this.baseUrl = getBaseUrl()
    this.isAudit = this.$route.query.isAudit
    this.surrenderFid = this.$route.query.surrenderFid
    this.parentSurrenderFid = this.$route.query.parentSurrenderFid
    this.contractFid = this.$route.query.contractFid
    this.initData()
  },
  // activated(){
  //   if(this.activatedKey){
  //     this.isAudit = this.$route.query.isAudit
  //     this.surrenderFid = this.$route.query.surrenderFid
  //     this.parentSurrenderFid = this.$route.query.parentSurrenderFid
  //     this.contractFid = this.$route.query.contractFid
  //     this.initData()
  //   }
  //   this.activatedKey++
  // },

  components:{
    TerminationInfo,
    Delivery,
    BalanceInfo,
    ImgShow,
    DismissedModal,
    ProtocolList,
    ZUpload
  },
  data () {
  return {
    pN:0,
    voucherListNum:0,


    activatedKey:0,
    projectName:'',
    isAudit:false,
    surrenderFid:'',
    parentSurrenderFid:'',
    contractFid:'',
    infoData:null,
    deliveryKey:0,
    balanceInfo:null,
    showImgKey:0,
    dismissedKey:0,
    getEnterpriseBalanceKey:0,
    imgSrc:''
  };
  },
  computed:{
    // num(){
    //   return this.$refs['vlist'].data.length
    //
    // },
    tag() {
      return this.$store.state.tagsView.visitedViews.find(tag => {
        return tag.path===this.$route.path
      });
    }
  },
  methods:{
    setNum(num){
      this.voucherListNum=num

    },
    uploadSuccess(res,file){
      console.log(res)
      if(!res.data){
        return
      }
      let params={
        fid:res.data.fid,
        attachmentImgUrl:res.data.url,
        moduleFid:this.surrenderFid,
        attachmentName: file.name
      }
      uploadVoucher(params).then(()=>{
        this.$Message.success('上传成功')
        this.$refs['vlist'].getVouchers()
      }).catch(error=>{})

    },
    getSignedText(){
      let params={
        contractFid:this.contractFid,
        busId:this.infoData.busId
      }
      getSignedText(params).then(res=>{
        if(!res.data){
          this.$Message.info('电子签章正在下载，请稍后刷新页面或返回重试')
          return
        }
        window.open(res.data.signPdfUrlForHttp,'_blank')
        // console.log(res)

      }).catch(error=>{

      })


    },
    noPro(){
      this.$Message.info('电子签章正在下载，请稍后刷新页面或返回重试')
    },
    closeTag(){
          this.$router.push({ name: 'order',params:{targetTab:'4'}})


      // this.$store.dispatch("delVisitedViews", this.tag).then( ()=> {
      //     this.$router.push({ name: 'audittermination'})
      //   })
    },
     dismissed() {
      this.dismissedKey++
    },
     getBasic(){
      if(this.surrenderFid){
        getSurrenderInfo(this.surrenderFid).then( res => {
          this.projectName = res.data.projectName
          this.infoData = res.data
        })
      }
    },
    getDeliverysInfo(){
      this.deliveryKey++
    },
    getEnterpriseBalance(){
      this.getEnterpriseBalanceKey++
    },
    initData(){
      this.getBasic()
      this.getDeliverysInfo()
       this.getEnterpriseBalance()
    },
    showImg(data) {
      this.imgSrc = data
      this.showImgKey++
    },
    pass(){
      let data = {
        auditType:1,
        surrenderFid:this.surrenderFid
      }
      confirmSurrAudit(data).then( res => {
        this.$Message.success('审核通过!');
        this.closeTag()
      })
    },

  }
}
</script>
<style scoped>
.btn-wrap {
  width: 100%;
  text-align: center;
  position: absolute;
  bottom: 30px;
}
.tab-right{
  padding: 8px 16px 16px;
}
</style>
